import React from 'react'
import './Parallax.css'
import {RxDoubleArrowDown} from "react-icons/rx";


export default function Parallax() {
  return (
    <>
        <section id='parallax'>
            <div className='parallax-container'>
                <img src="/parallax.jpg" alt="" />

                <div className='parallax-content'>
                    <p> Welcome To My Website! </p>
                    <h1> Owen Marscel </h1>
                    <h3> I'm a Full-Stack Developer </h3>
                </div>
                
                <div className='scroll-icon'>
                    <a href="#about">
                        <span> <RxDoubleArrowDown/> </span>
                    </a>
                </div>
            </div>
            
        </section>
    </>
  )
}
